import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";
import Datetime from "react-datetime";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getCountry,
  getCustomer,
  get_lead_old_data,
  getb2b,
  updateLead,
  getCity,
  getremaincreditforleaduser,
  getOrganizationDataWithoutPagination,
  gatAllOackageWithoutPagination,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { Map, GoogleApiWrapper } from "google-maps-react";
import Autocomplete from "react-google-autocomplete";
import { GoogleMap, Marker } from "react-google-maps";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editlead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: true,
      country_data: [],
      customerdetail: [],
      name: "",
      nameError: null,
      email: "",
      emailError: null,
      mobileno: "",
      mobilenoError: null,
      phone: null,
      phoneError: null,
      ccode: "+94",
      leadowner: "",
      leadownerError: null,
      leadstatus: "0",
      leadstatusError: null,
      address_line_1: "",
      address_line_1Error: null,
      address_line_2: "",
      address_line_2Error: null,
      city: "",
      pcode: "+94",
      pccode: "+94",
      eccode: "+94",
      cityError: null,
      country: "0",
      countryError: null,
      state: "",
      stateError: null,
      postalcode: "",
      postalcodeError: null,
      comment: "",
      commentError: null,
      organizationError: null,
      organization: "",
      source: "1",
      organizationdetail: [],
      _notificationSystem: null,
      cardHidden: true,
      city_info: [],
      gender: "",
      age: "",
      dob: null,
      NIC_passportnum: "",
      bodytem: "",
      occupation: "",
      MOHarea: "",
      channel: "",
      partial_contact: "",
      partial_contactError: null,
      partial_email: "",
      partial_emailError: null,
      partial: false,
      partial_name: "",
      emergency_contact_name: "",
      emergency_contact_num: "",
      emergency_contact_numError: null,
      userrole: "",
      symptoms: [],
      deleted_address_id: [],
      customaddress: "",
      customaddressError: null,
      remiancredit: "",
      is_b2b: "",
      store_id: "",
      symptomsdata: [
        { id: 1, label: "Fever", checked: false },
        { id: 2, label: "Cough", checked: false },
        { id: 3, label: "Sore Throat", checked: false },
        { id: 4, label: "Difficulty in Breathing", checked: false },
      ],
      Epidemiological_Evidence: [],
      Epidemiological_Evidence_data: [
        {
          id: 11,
          label: "Contact history with diagnosed nCoV-19",
          checked: false,
        },
        {
          id: 12,
          label: "Contact history with suspect nCoV-19",
          checked: false,
        },
        {
          id: 13,
          label: "Patient from a lockdown/isolated area",
          checked: false,
        },
      ],

      addresslist: [
        {
          srno: 1,
          id: 0,
          address_line_1: "",
          address_line_2: "",
          city: "0",
          state: "",
          country: 0,
          postalcode: "",
          addresstypeError: "",
          customaddressError: "",
          addresstype: "",
          customaddress: "",
          latitude: "",
          longitude: "",
        },
      ],
      errormessages: [],
      country_code: "",
      organizationOption: [],
      lead_packages: [],
      packagesOption: [],
      lat: null,
      lng: null,
      selectedPlace: { name: "" },
      formattedAddress: "",
      formatAddressLine1: "",
      coordinates: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.emailInput = React.createRef();
    this.handleEpidemiological_Evidence =
      this.handleEpidemiological_Evidence.bind(this);
    this.handlesymptoms = this.handlesymptoms.bind(this);
    this.checkpatient = this.checkpatient.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleRemoveClick = (index) => {
    const list = [...this.state.addresslist];

    var deleted_address_id = this.state.deleted_address_id;
    deleted_address_id.push(list[index]["id"]);
    this.setState({ deleted_address_id: deleted_address_id });

    list.splice(index, 1);
    this.setState({ addresslist: list });
    const list1 = list;

    let count_x = 1;

    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      count_x++;
    });
    this.serial = count_x;
  };

  splitDialCodeNumber(number, defaultCode = "+94") {
    const rawNumber = number ? number.toString().trim() : "";

    if (!rawNumber) {
      return { code: defaultCode, number: "" };
    }

    if (rawNumber.startsWith("+852")) {
      return { code: "+852", number: rawNumber.slice(4) };
    }

    if (rawNumber.startsWith("+94") || rawNumber.startsWith("+91")) {
      return { code: rawNumber.slice(0, 3), number: rawNumber.slice(3) };
    }

    if (rawNumber.length > 9 && rawNumber.startsWith("852")) {
      return { code: "+852", number: rawNumber.slice(3) };
    }

    if (
      rawNumber.length > 9 &&
      (rawNumber.startsWith("94") || rawNumber.startsWith("91"))
    ) {
      return { code: `+${rawNumber.slice(0, 2)}`, number: rawNumber.slice(2) };
    }

    return { code: defaultCode, number: rawNumber };
  }

  handlesymptoms(e, i) {
    var checked = e.target.checked;
    var list = [...this.state.symptomsdata];
    list[i]["checked"] = checked;
    this.setState({ symptoms: list });
  }
  handleEpidemiological_Evidence(e, i) {
    var checked = e.target.checked;
    var list = [...this.state.Epidemiological_Evidence_data];
    list[i]["checked"] = checked;
    this.setState({ Epidemiological_Evidence: list });
    console.log(this.state.Epidemiological_Evidence);
  }
  handleAddClick = () => {
    this.setState({
      addresslist: [
        ...this.state.addresslist,
        {
          srno: this.getSerial(),
          id: 0,
          address_line_1: "",
          address_line_2: "",
          city: "0",
          state: "",
          country: 1,
          postalcode: "",
          addresstype: "",
          customaddress: "",
          is_active: 1,
          latitude: "",
          longitude: "",
        },
      ],
    });
  };
  // handleSelectChange = (index , value) => {
  //   const list = [...this.state.addresslist];
  //   // console.log(list[index]['address_line_1']);

  //   this.setState({addresslist:list })

  // };
  handleInputChange = (e, index, country) => {
    const { name, value } = e.target;
    // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
    const list = [...this.state.addresslist];
    list[index][name] = value;

    if (country) {
      const countryCode = this.state.country_data.find(
        (item) => item.id == value,
      ).country_code;
      this.setState({ country_code: countryCode });
    }

    if (list[index]["country"] != "0") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var country_id = list[index]["country"];
      getCity(obj, country_id).then((res) => {
        this.setState({ city_info: res.data });
      });
    } else if (list[index]["country"] == "0") {
      this.setState({ city_info: [] });
    }

    this.setState({ addresslist: list });
  };

  handleInputLocationChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.addresslist];
    // list[index][name] = value;

    if (value) {
      const coordinatesArray = value.split(",");

      if (coordinatesArray.length === 2) {
        const lat = coordinatesArray[0];
        const lng = coordinatesArray[1];

        // Update state with new latitude and longitude
        this.setState((prevState) => {
          const updatedAddressList = [...prevState.addresslist];
          updatedAddressList[index] = {
            ...updatedAddressList[index],
            latitude: lat,
            longitude: lng,
          };
          return { addresslist: updatedAddressList };
        });
      }
    } else {
      this.setState((prevState) => {
        const updatedAddressList = [...prevState.addresslist];
        updatedAddressList[index] = {
          ...updatedAddressList[index],
          latitude: "",
          longitude: "",
        };
        return { addresslist: updatedAddressList };
      });
      console.log("Geometry location not available for this place");
    }
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Customer</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/lead");
    }, 3000);
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ userrole: token.role, store_id: token.store_id });
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    this.getcity(1);

    getCountry(obj).then((res) => {
      var data = res.data;

      // let country_D = [];
      // data.map((x, i) => {
      //   country_D.push({ value:x.id , label: x.country_name})
      // })
      this.setState({
        country_data: data,
      });
    });
    getCustomer(obj).then((response) => {
      // console.log(response);
      var customerdata = response.data;
      this.setState({
        customerdetail: customerdata,
      });
    });
    let pg_no = 1;
    let organizationData = [];
    // while (compelte == 1) {
    getOrganizationDataWithoutPagination(obj).then((res) => {
      let Org = [];
      const companyData = res.data;
      organizationData = res.data;
      const organizationDetail = companyData.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });

      Org = [
        { value: "", label: "Select organization" },
        ...organizationDetail,
      ];
      this.setState({ organizationOption: Org });
    });

    gatAllOackageWithoutPagination(obj).then((res) => {
      let packages = [];
      const packagesData = res.data.data;
      const packagesDetail = packagesData.map((data) => {
        return {
          value: data.id,
          label: data.title,
        };
      });

      packages = [{ value: "", label: "Select Packages" }, ...packagesDetail];
      this.setState({ packagesOption: packages });
    });

    var id = JSON.parse(localStorage.getItem("leadID"));
    get_lead_old_data(id, obj).then((lead_data) => {
      var leaddata = lead_data.data;
      var address = leaddata.address;
      // console.log(leaddata.organization_id);
      var com = "";
      if (leaddata.source == 1) {
        com = "1";
      } else if (leaddata.source == 2) {
        com = "2";
      } else if (leaddata.source == 3) {
        com = "3";
      } else if (leaddata.source == 4) {
        com = "4";
      }
      var mobileno = "";

      var is_b2buser = "";
      if (leaddata.is_b2b == "0") {
        is_b2buser = "2";
      } else if (leaddata.is_b2b == "1") {
        is_b2buser = "1";
      }

      var lead_selectedop = [];
      gatAllOackageWithoutPagination(obj).then((res) => {
        // const packagesData = res.data.data;
        if (!!lead_data.data.lead_catalogue_package) {
          const lead_packages = lead_data.data.lead_catalogue_package;
          const getDirectAssignPackages = lead_packages
            .filter(
              (data) =>
                data.is_direct_assigned ||
                (data.catalogue_package &&
                  data.catalogue_package.title === "Flash One⚡"),
            )
            .map((data) => ({
              value: data.package_id,
              label: data.catalogue_package.title,
            }));
          this.setState({ lead_packages: getDirectAssignPackages });
          // const getDirectAssignPackages =
          //   lead_packages &&
          //   lead_packages.map((lan, idx) => {
          //     console.log(`LanA${idx}`, lan);
          //     if (
          //       lan.is_direct_assigned ||
          //       lan.catalogue_package.title === "Flash One⚡"
          //     ) {
          //       console.log(`LanB${idx}`, lan);
          //       if (!!lan) {
          //         return {
          //           value: lan.package_id,
          //           label: lan.catalogue_package.title,
          //         };
          //       }
          //     }
          //     console.log(`LanC${idx}`, lan);

          //     // const title = packagesData.filter(
          //     //   (item) => item.id === lan.package_id
          //     // );
          //     // var details = { value: lan.package_id, label: title[0].title };
          //     // if (lan.is_direct_assigned || title[0].title === "Flash One⚡") {
          //     //   lead_selectedop.push(details);
          //     // }
          //   });
        }
      });

      let symptoms_olddata = [];
      let sy = [];
      var phone = null;
      var partial_contact = "";
      var emergency_contact_no = "";
      var mobileno = "";
      var ccode = "+94";
      var pcode = "+94";
      var pccode = "+94";
      var eccode = "+94";
      if (
        this.state.userrole == 6 ||
        this.state.userrole == 1 ||
        this.state.userrole == 2
      ) {
        if (leaddata.lead_detail != null) {
          const list = [...this.state.symptomsdata];
          if (leaddata.lead_detail.symptoms != null) {
            const splic = leaddata.lead_detail.symptoms.split(",");
            splic.map((fd) => {
              this.state.symptomsdata.map((s, i) => {
                if (list[i]["label"] == fd) {
                  list[i]["checked"] = true;
                  this.setState({ symptomsdata: list, symptoms: list });
                }
              });
            });
          }
          const list_epi = [...this.state.Epidemiological_Evidence_data];
          if (leaddata.lead_detail.epidemiological_evidence != null) {
            const splic_epi =
              leaddata.lead_detail.epidemiological_evidence.split(",");
            splic_epi.map((fd) => {
              this.state.Epidemiological_Evidence_data.map((s, i) => {
                if (list_epi[i]["label"] == fd) {
                  list_epi[i]["checked"] = true;
                  this.setState({
                    Epidemiological_Evidence_data: list_epi,
                    Epidemiological_Evidence: list_epi,
                  });
                }
              });
            });
          }
          if (leaddata.lead_detail.patient_contact_no != null) {
            const patientPhone = this.splitDialCodeNumber(
              leaddata.lead_detail.patient_contact_no,
              pccode,
            );
            partial_contact = patientPhone.number;
            pccode = patientPhone.code;
          }
          if (leaddata.lead_detail.emergency_contact_no != null) {
            const emergencyPhone = this.splitDialCodeNumber(
              leaddata.lead_detail.emergency_contact_no,
              eccode,
            );
            emergency_contact_no = emergencyPhone.number;
            eccode = emergencyPhone.code;
          }

          this.setState({
            gender: leaddata.lead_detail.gender,
            age: leaddata.lead_detail.age,
            pccode: pccode,
            eccode: eccode,
            NIC_passportnum: leaddata.lead_detail.passport_no,
            bodytem: leaddata.lead_detail.body_tem,
            occupation: leaddata.lead_detail.occupation,
            MOHarea: leaddata.lead_detail.moh_area,
            partial_name: leaddata.lead_detail.patient_name,
            partial_contact: partial_contact,
            partial_email: leaddata.lead_detail.patient_email_id,
            emergency_contact_name: leaddata.lead_detail.emergency_contact_name,
            emergency_contact_num: emergency_contact_no,
          });

          if (
            leaddata.lead_detail.patient_contact_no != null ||
            leaddata.lead_detail.patient_name != null ||
            leaddata.lead_detail.patient_email_id != null
          ) {
            if (
              leaddata.lead_detail.patient_contact_no.length > 0 ||
              leaddata.lead_detail.patient_name.length > 0 ||
              leaddata.lead_detail.patient_email_id.length > 0
            ) {
              this.setState({ partial: true });
            }
          }
        }
      }
      if (leaddata.date_of_birth != null) {
        this.setState({ dob: new Date(leaddata.date_of_birth) });
      }
      if (leaddata.mobile_no != null) {
        const mobilePhone = this.splitDialCodeNumber(leaddata.mobile_no, ccode);
        mobileno = mobilePhone.number;
        ccode = mobilePhone.code;
      }
      if (leaddata.phone != null) {
        const landPhone = this.splitDialCodeNumber(leaddata.phone, pcode);
        phone = landPhone.number;
        pcode = landPhone.code;
      }

      let organizationObject = {};
      if (leaddata.b2b || leaddata.b2b !== null) {
        organizationObject = {
          value: leaddata.b2b.id,
          label: leaddata.b2b.company_name,
        };
      } else {
        organizationObject = { value: "", label: "" };
      }
      // let getPackageValue = leaddata.lead_catalogue_package.map((pkg) => ({
      //   value: pkg.catalogue_package.id,
      //   label: pkg.catalogue_package.title,
      // }));

      this.setState({
        name: leaddata.name,
        email: leaddata.email,
        mobileno: mobileno,
        phone: phone,
        ccode: ccode,
        pcode: pcode,
        leadstatus: leaddata.leads_status,
        comment: leaddata.comments,
        source: com,
        channel: leaddata.channel,
        organization: organizationObject,
        is_b2b: is_b2buser,
        // lead_packages: title.label,
      });

      let addressform = [];
      // console.log(leaddata)
      leaddata.address.map((x, i) => {
        // console.log(x,'address')
        let addressdata = "";
        let custom_address = "";
        if (x.address_type != null) {
          if (x.address_type != "Home" && x.address_type != "Office") {
            addressdata = "Custom";
            custom_address = x.address_type;
          } else {
            addressdata = x.address_type;
          }
        }

        const addressLineOne =
          x.address_line1 && x.address_line1.replace(`${x.address_line2},`, "");

        addressform.push({
          srno: this.getSerial(),
          id: x.id,
          address_line_1: addressLineOne || this.state.formattedAddress,
          address_line_2: x.address_line2,
          city: x.city,
          state: x.state,
          country: x.country_id,
          postalcode: x.postal_code,
          addresstype: addressdata,
          customaddress: custom_address,
          is_active: x.is_active,
          latitude: x.latitude,
          longitude: x.longitude,
        });
      });
      this.setState({ addresslist: addressform });
    });
    getremaincreditforleaduser(id, obj).then((res) => {
      // console.log(res.data.data.remainingCredit,'remian credit ');
      if (res.data != null) {
        this.setState({ remiancredit: res.data.remainingCredit });
      } else {
        this.setState({ remiancredit: 0 });
      }
    });
  }

  serial = 1;
  getSerial() {
    return this.serial++;
  }

  getcity(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var country_id = id;
    getCity(obj, country_id).then((res) => {
      this.setState({ city_info: res.data });
    });
  }
  handleDateChange = (date) => {
    this.setState({
      dob: date,
    });
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  checkpatient(e) {
    var checked = e.target.checked;

    if (checked == false) {
      this.setState({
        partial_contact: "",
        partial_email: "",
        partial_name: "",
        partial_contactError: null,
        partial_emailError: null,
      });
    }
    this.setState({ partial: checked });
  }
  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.name.length == 0) {
      error = true;
      this.setState({
        nameError: <small className="text-danger">Name is required.</small>,
      });
    } else {
      this.setState({ nameError: null });
    }

    if (
      (this.state.mobileno.length < 9 && this.state.organization == "0") ||
      (this.state.mobileno.length > 11 && this.state.organization == "0")
    ) {
      error = true;
      this.setState({
        mobilenoError: (
          <small className="text-danger">
            Please enter mobile nunber from 9 to 11 digit.
          </small>
        ),
      });
    } else if (
      this.state.organization != "0" &&
      this.state.mobileno.length > 0
    ) {
      error = false;
      if (this.state.mobileno.length < 9 || this.state.mobileno.length > 11) {
        error = true;
        this.setState({
          mobilenoError: (
            <small className="text-danger">
              Please enter mobile nunber from 9 to 11 digit.
            </small>
          ),
        });
      }
    } else {
      this.setState({ mobilenoError: null });
    }
    if (this.state.email != null) {
      if (this.state.email.length == 0) {
        this.setState({ emailError: null });
      } else if (this.state.email.length > 0) {
        var emailRex = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        if (emailRex.test(this.state.email) === false) {
          error = true;
          this.setState({
            emailError: (
              <small className="text-danger">
                Email format should be abc@doe.com.
              </small>
            ),
          });
        }
      } else {
        this.setState({ emailError: null });
      }
    }
    if (this.state.partial_contact != null) {
      if (this.state.partial_contact.length == 0) {
        this.setState({ partial_contactError: null });
      } else if (this.state.partial_contact.length > 0) {
        if (
          this.state.partial_contact.length < 9 ||
          this.state.partial_contact.length > 11
        ) {
          error = true;
          this.setState({
            partial_contactError: (
              <small className="text-danger">
                Please enter pantient phone no from 9 to 11 digit.
              </small>
            ),
          });
        }
      } else {
        this.setState({ partial_contactError: null });
      }
    }
    if (this.state.emergency_contact_num != null) {
      if (this.state.emergency_contact_num.length == 0) {
        this.setState({ emergency_contact_numError: null });
      } else if (this.state.emergency_contact_num.length > 0) {
        if (
          this.state.emergency_contact_num.length < 9 ||
          this.state.emergency_contact_num.length > 11
        ) {
          error = true;
          this.setState({
            emergency_contact_numError: (
              <small className="text-danger">
                Please enter emergency contact person number from 9 to 11 digit.
              </small>
            ),
          });
        }
      } else {
        this.setState({ emergency_contact_numError: null });
      }
    }
    if (this.state.phone == null || this.state.phone == "") {
      this.setState({ phoneError: null });
    } else if (this.state.phone != null) {
      if (this.state.phone != "") {
        if (this.state.phone.length < 9 || this.state.phone.length > 11) {
          error = true;
          this.setState({
            phoneError: (
              <small className="text-danger">
                Please enter phone number from 9 to 11 digit.
              </small>
            ),
          });
        }
      }
    } else {
      this.setState({ phoneError: null });
    }
    if (this.state.partial_email != null) {
      if (this.state.partial_email.length == 0) {
        this.setState({ partial_emailError: null });
      } else if (this.state.partial_email.length > 0) {
        var emailRex = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        if (emailRex.test(this.state.partial_email) === false) {
          error = true;
          this.setState({
            partial_emailError: (
              <small className="text-danger">
                Pantient Email format should be abc@doe.com.
              </small>
            ),
          });
        }
      } else {
        this.setState({ partial_emailError: null });
      }
    }

    if (this.state.leadstatus == "0") {
      error = true;
      this.setState({
        leadstatusError: (
          <small className="text-danger">Lead Status is required.</small>
        ),
      });
    } else {
      this.setState({ leadstatusError: null });
    }
    const list = [...this.state.addresslist];
    if (this.state.addresslist.length != 0) {
      this.state.addresslist.map((x, i) => {
        /* if (x.country == 0) {
          list[i]["country_error"] = (
            <small className="text-danger"> Country is required. </small>
          );
          error = true;
        }

        if (x.city == 0) {
          list[i]["city_error"] = (
            <small className="text-danger"> City is required. </small>
          );
          error = true;
        }

        if (x.addresstype) {
          const list = [...this.state.addresslist];
          list[i]["addresstypeError"] = (
            <small className="text-danger">Addresstype is required</small>
          );
          error = true;
        }*/
        // if (x.addresstype == "Custom") {
        //   if (x.customaddress == "") {
        //     const list = [...this.state.addresslist];
        //     list[i]["customaddressError"] = (
        //       <small className="text-danger">Custom address is required</small>
        //     );
        //     error = true;
        //   }
        // }
      });

      if (error) {
        this.emailInput.current.focus();
        this.setState({ addresslist: list });
      }
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      const { lat, lng } = this.state;

      var id = JSON.parse(localStorage.getItem("leadID"));
      let addressform = [];
      this.state.addresslist.map((x, i) => {
        // const bindAddress = `${x.address_line_2},${""} ${x.address_line_1}`;

        let addressdata = "";

        if (x.addresstype == "Custom") {
          addressdata = x.customaddress;
        } else {
          addressdata = x.addresstype;
        }

        addressform.push({
          id: x.id,
          address_line1: x.address_line_1,
          address_line2: x.address_line_2,
          city: x.city,
          state: x.state,
          country_id: x.country,
          postal_code: x.postalcode,
          address_type: addressdata,
          is_active: x.is_active,
          latitude: lat || x.latitude,
          longitude: lng || x.longitude,
        });
      });
      let symptoms_details = [];
      let Epidemiological_Evidence_details = [];

      if (
        this.state.userrole == 6 ||
        this.state.userrole == 1 ||
        this.state.userrole == 2
      ) {
        this.state.symptoms.map((s) => {
          if (s.checked == true) {
            symptoms_details.push(s.label);
          }
        });
        this.state.Epidemiological_Evidence.map((e) => {
          if (e.checked == true) {
            Epidemiological_Evidence_details.push(e.label);
          }
        });
      }
      var today = null;
      console.log(this.state.dob, "dob");

      if (this.state.dob != null) {
        if (this.state.dob != "") {
          const date = new Date(this.state.dob);
          var dd = ("0" + date.getDate()).slice(-2);
          var mm = ("0" + (date.getMonth() + 1)).slice(-2);
          var yyyy = date.getFullYear();
          today = yyyy + "-" + mm + "-" + dd;
        }
      }

      var channel = "admin";
      var mobile = "";
      var phone = null;
      var emergency_contact_num = "";
      var partial_contact = "";
      if (this.state.mobileno.length != 0) {
        mobile = this.state.ccode + this.state.mobileno;
      }
      if (this.state.phone != null) {
        phone = this.state.pcode + this.state.phone;
      }
      if (this.state.emergency_contact_num.length != 0) {
        emergency_contact_num =
          this.state.eccode + this.state.emergency_contact_num;
      }
      if (this.state.partial_contact.length != 0) {
        partial_contact = this.state.pccode + this.state.partial_contact;
      }
      //console.log(this.state.deleted_address_id,"deleted_address_id");
      //console.log(addressform,"addressform");
      //return ;

      var is_b2buser = "";
      if (this.state.is_b2b == "1") {
        is_b2buser = "1";
      } else if (this.state.is_b2b == "2") {
        is_b2buser = "0";
      }

      this.setState({ processing: false }, () => {
        updateLead(
          this.state.name,
          this.state.email,
          mobile,
          phone,
          this.state.leadstatus,
          addressform,
          this.state.comment,
          this.state.source,
          this.state.organization.value,
          this.state.channel !== channel ? this.state.channel : channel,
          this.state.gender,
          today,
          this.state.NIC_passportnum,
          this.state.bodytem,
          this.state.occupation,
          this.state.MOHarea,
          this.state.partial_name,
          partial_contact,
          this.state.partial_email,
          this.state.emergency_contact_name,
          emergency_contact_num,
          symptoms_details,
          Epidemiological_Evidence_details,
          id,
          this.state.deleted_address_id,
          is_b2buser,
          obj,
          this.state.country_code,
          this.state.lead_packages,
          this.state.store_id === null ? "" : this.state.store_id,
        )
          .then((res) => {
            const responseData = res && res.data ? res.data : {};

            // Always allow another attempt once the API has responded.
            this.setState({ processing: true });

            if (responseData.success === false) {
              const validationErrors = responseData.data;
              if (
                validationErrors &&
                Object.keys(validationErrors).length !== 0
              ) {
                const ermessage = [];
                for (const key of Object.keys(validationErrors)) {
                  ermessage.push(validationErrors[key]);
                }
                this.setState({ errormessages: ermessage });
                const msg = validationErrors;
                this.emailInput.current.focus();
                this.setState({
                  mobilenoError: (
                    <small className="text-danger">{msg.mobile_no}</small>
                  ),
                });
              } else {
                this.handleClick("bl");
              }
            } else if (
              responseData.success === true ||
              (res.status >= 200 && res.status < 300)
            ) {
              this.handleSuccess("bl");
            } else {
              this.handleNetworkError("bl", { data: responseData });
            }
          })
          .catch((error) => {
            console.log(error, "== error");
            this.setState({ processing: true });
            this.handleNetworkError("bl", error);
          });
      });
    }
  };

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  onParentOrganizationChange = (value) => {
    this.setState({
      organization: value,
    });
  };

  handlePlaceSelected = (place, index) => {
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.setState((prevState) => {
        const updatedAddressList = [...prevState.addresslist];
        updatedAddressList[index] = {
          ...updatedAddressList[index],
          latitude: lat,
          longitude: lng,
          selectedPlace: { name: place.name },
          formattedAddress: place.formatted_address,
          address_line_1: place.formatted_address,
        };
        return { addresslist: updatedAddressList };
      });
    } else {
      console.log("Geometry location not available for this place");
    }
  };

  onMapReady = (mapProps, map, index) => {
    this[`map${index}`] = map;
  };

  render() {
    console.log(this.state.lead_packages, "value");
    const country = this.state.country_data;

    const organizationdetail = this.state.organizationdetail;
    const errormessages = this.state.errormessages;
    // const { lat, lng } = this.state;

    // const googleURL = `https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;coord=${lat},${lng}&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed`;
    // console.log("googleURL", googleURL);

    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.emailInput}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <Row>
                      <Col md={12} lg={12} xs={12} sm={12}>
                        <h5 style={{ float: "right" }}>
                          Available flash credits :{" "}
                          {(this.state.remiancredit - 0).toFixed(2)}
                        </h5>
                      </Col>
                    </Row>
                    <Row style={{ paddingTop: "15px", "margin-top": "-17px" }}>
                      <h4
                        style={{
                          "text-align": " left",
                          "font-weight": "bold",
                          margin: "0",
                          paddingLeft: "12px",
                        }}
                      >
                        Subscriber Details
                      </h4>
                      <Col md={6} xs={12} sm={6}>
                        <FormGroup>
                          <ControlLabel>Name</ControlLabel>
                          <FormControl
                            type="text"
                            required
                            name="name"
                            onChange={(event) => {
                              this.setState({ name: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    nameError: (
                                      <small className="text-danger">
                                        Name is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ nameError: null });
                            }}
                            value={this.state.name || ""}
                            placeholder="Your  Name"
                          />
                          {this.state.nameError}
                        </FormGroup>
                        <Col>
                          <FormGroup>
                            <ControlLabel>Organization </ControlLabel>
                            <Select
                              name="source"
                              value={this.state.organization}
                              placeholder="Select Organization"
                              onChange={(value) =>
                                this.onParentOrganizationChange(value)
                              }
                              options={this.state.organizationOption}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <ControlLabel className="roleLabel">
                              Packages{" "}
                            </ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Select Packages"
                              name="lead_packages"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.lead_packages}
                              onChange={(value) => {
                                this.setState({ lead_packages: value });
                              }}
                              options={this.state.packagesOption}
                            />
                          </FormGroup>
                        </Col>

                        {/* <FormGroup>
                          <ControlLabel>Organization</ControlLabel>
                          <select
                            name="organization"
                            value={this.state.organization}
                            onChange={(event) => {
                              this.setState({
                                organization: event.target.value,
                              });
                            }}
                            className="form-control">
                            <option value="0">Select Organization</option>
                            {organizationdetail.map((organizationdata) => (
                              <option value={organizationdata.id}>
                                {organizationdata.company_name}
                              </option>
                            ))}
                          </select>
                        </FormGroup> */}
                        <FormGroup>
                          <ControlLabel>Lead Status</ControlLabel>
                          <select
                            name="leadstatus"
                            value={this.state.leadstatus}
                            onChange={(event) => {
                              this.setState({ leadstatus: event.target.value });
                              event.target.value === "0"
                                ? this.setState({
                                    leadstatusError: (
                                      <small className="text-danger">
                                        Lead Status is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ leadstatusError: null });
                            }}
                            className="form-control"
                          >
                            <option value="0" disabled>
                              Select Lead Status
                            </option>
                            <option value="1" disabled>
                              New
                            </option>
                            <option value="2" disabled>
                              Negotiation
                            </option>
                            <option value="3">Subscribed</option>
                            <option value="4" disabled>
                              Lost
                            </option>
                          </select>
                          {this.state.leadstatusError}
                        </FormGroup>
                        {this.state.leadstatus == 3 ? (
                          <FormGroup>
                            <ControlLabel>Source</ControlLabel>
                            <div className="order_source_data">
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="5"
                                option="1"
                                name="source"
                                onChange={this.onChange}
                                checked={this.state.source === "1"}
                                label="Flash"
                              />
                              &nbsp;
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="6"
                                option="2"
                                name="source"
                                onChange={this.onChange}
                                checked={this.state.source === "2"}
                                label="oPharma"
                              />
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="7"
                                option="3"
                                name="source"
                                onChange={this.onChange}
                                checked={this.state.source === "3"}
                                label="MyPharma"
                              />
                              <Radio
                                style={{ display: "inline-block" }}
                                number="8"
                                option="4"
                                name="source"
                                onChange={this.onChange}
                                checked={this.state.source === "4"}
                                label="Daraz"
                              />
                              <Radio
                                style={{ display: "inline-block" }}
                                number="9"
                                option="5"
                                name="source"
                                onChange={this.onChange}
                                checked={this.state.source === "5"}
                                label="Kapuraka"
                              />
                              <Radio
                                style={{ display: "inline-block" }}
                                number="10"
                                option="6"
                                name="source"
                                onChange={this.onChange}
                                checked={this.state.source === "6"}
                                label="E-channeling"
                              />
                            </div>
                          </FormGroup>
                        ) : (
                          ""
                        )}

                        <FormGroup>
                          <ControlLabel style={{ position: "absolute" }}>
                            Is B2B
                          </ControlLabel>
                          <br />
                          <div className="order_source_data">
                            <Radio
                              // style={{'display':'inline-block'}}
                              number="501"
                              option="1"
                              name="is_b2b"
                              onChange={this.onChange}
                              checked={this.state.is_b2b === "1"}
                              label="Yes"
                            />
                            &nbsp;
                            <Radio
                              // style={{'display':'inline-block'}}
                              number="601"
                              option="2"
                              name="is_b2b"
                              onChange={this.onChange}
                              checked={this.state.is_b2b === "2"}
                              label="No"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={6} sm={6} xs={12}>
                        <FormGroup>
                          <ControlLabel>Email</ControlLabel>
                          <FormControl
                            type="email"
                            name="email"
                            onChange={(event) => {
                              this.setState({ email: event.target.value });
                              var emailRex =
                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                              emailRex.test(event.target.value) === false
                                ? this.setState({
                                    emailError: (
                                      <small className="text-danger">
                                        Email format should be{" "}
                                        <i>abc@doe.com</i>.
                                      </small>
                                    ),
                                  })
                                : this.setState({ emailError: null });
                            }}
                            value={this.state.email || ""}
                            placeholder="Your email "
                            autoComplete="off"
                          />
                          {this.state.emailError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Mobile No</ControlLabel>
                          <Col md={12}>
                            <Col
                              md={2}
                              className="no-padding"
                              style={{ marginTop: "4px" }}
                            >
                              <select
                                onChange={this.onChange}
                                name="ccode"
                                value={this.state.ccode}
                                className="form-control"
                              >
                                <option value="+94">+94</option>
                                <option value="+91">+91</option>
                              </select>
                            </Col>
                            <Col md={10}>
                              <FormControl
                                type="number"
                                required
                                name="mobileno"
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    mobileno: event.target.value,
                                  });
                                  event.target.value.length < 9 ||
                                  event.target.value.length > 11
                                    ? this.setState({
                                        mobilenoError: (
                                          <small className="text-danger">
                                            Please enter mobile nunber from 9 to
                                            11 digit.
                                          </small>
                                        ),
                                      })
                                    : this.setState({ mobilenoError: null });
                                }}
                                value={this.state.mobileno || ""}
                                placeholder="Your  Mobileno"
                              />
                            </Col>
                            {this.state.mobilenoError}
                          </Col>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Phone No</ControlLabel>
                          <Col md={12}>
                            <Col
                              md={2}
                              className="no-padding"
                              style={{ marginTop: "4px" }}
                            >
                              <select
                                onChange={this.onChange}
                                name="pcode"
                                value={this.state.pcode}
                                className="form-control"
                              >
                                <option value="+94">+94</option>
                                <option value="+91">+91</option>
                              </select>
                            </Col>
                            <Col md={10}>
                              <FormControl
                                type="number"
                                required
                                name="phone"
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    phone: event.target.value,
                                  });
                                  event.target.value.length < 9 ||
                                  event.target.value.length > 11
                                    ? this.setState({
                                        phoneError: (
                                          <small className="text-danger">
                                            Please enter phone nunber from 9 to
                                            11 digit.
                                          </small>
                                        ),
                                      })
                                    : this.setState({ phoneError: null });
                                }}
                                value={this.state.phone || ""}
                                placeholder="Your  Phone No"
                              />
                            </Col>
                            {this.state.phoneError}
                          </Col>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Gender</ControlLabel>

                          <div className="order_source_data">
                            <Radio
                              // style={{'display':'inline-block'}}
                              number="31"
                              option="male"
                              name="gender"
                              onChange={this.onChange}
                              checked={this.state.gender === "male"}
                              label="Male"
                            />
                            &nbsp;
                            <Radio
                              // style={{'display':'inline-block'}}
                              number="32"
                              option="female"
                              name="gender"
                              onChange={this.onChange}
                              checked={this.state.gender === "female"}
                              label="Female"
                            />
                            <Radio
                              // style={{'display':'inline-block'}}
                              number="10"
                              option="other"
                              name="gender"
                              onChange={this.onChange}
                              checked={this.state.gender === "other"}
                              label="Other"
                            />
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Date Of Birth</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{ placeholder: "Order Date" }}
                            // defaultValue={new Date()}
                            closeOnSelect={true}
                            value={this.state.dob}
                            onChange={this.handleDateChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <h4 style={{ textAlign: "left", fontWeight: "bold" }}>
                      Diagnostic Details
                    </h4>
                    <Row>
                      <Col md={6} xs={12} sm={6}>
                        {this.state.userrole == 6 ||
                        this.state.userrole == 1 ||
                        this.state.userrole == 2 ? (
                          <>
                            <FormGroup>
                              <ControlLabel>NIC/Passport No</ControlLabel>
                              <FormControl
                                type="text"
                                name="NIC_passportnum"
                                placeholder="Enter NIC/Passport No"
                                onChange={this.onChange}
                                value={this.state.NIC_passportnum}
                                min={1}
                              ></FormControl>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>Occupation</ControlLabel>
                              <FormControl
                                type="text"
                                name="occupation"
                                value={this.state.occupation}
                                placeholder="Enter Occupation"
                                onChange={this.onChange}
                              ></FormControl>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>MOH Area</ControlLabel>
                              <FormControl
                                type="text"
                                name="MOHarea"
                                value={this.state.MOHarea}
                                placeholder="Enter MOH Area"
                                onChange={this.onChange}
                              ></FormControl>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>
                                Emergency Contact Person name
                              </ControlLabel>
                              <FormControl
                                type="text"
                                name="emergency_contact_name"
                                value={this.state.emergency_contact_name}
                                placeholder="Enter Emergency Contact Person name"
                                onChange={this.onChange}
                              ></FormControl>
                            </FormGroup>

                            <FormGroup>
                              <Checkbox
                                number="15"
                                checked={this.state.partial}
                                onChange={this.checkpatient}
                                label="Is this you ?"
                              ></Checkbox>
                            </FormGroup>
                            {this.state.partial == true ? (
                              <>
                                <FormGroup>
                                  <ControlLabel>Patient name</ControlLabel>
                                  <FormControl
                                    type="text"
                                    name="partial_name"
                                    value={this.state.partial_name}
                                    placeholder="Enter Patient name"
                                    onChange={this.onChange}
                                  ></FormControl>
                                </FormGroup>
                                <FormGroup>
                                  <ControlLabel>Patient Phone no</ControlLabel>
                                  <Col md={12}>
                                    <Col
                                      md={2}
                                      className="no-padding"
                                      style={{ marginTop: "4px" }}
                                    >
                                      <select
                                        onChange={this.onChange}
                                        name="pccode"
                                        value={this.state.pccode}
                                        className="form-control"
                                      >
                                        <option value="+94">+94</option>
                                        <option value="+91">+91</option>
                                      </select>
                                    </Col>
                                    <Col md={10}>
                                      <FormControl
                                        type="number"
                                        name="partial_contact"
                                        value={this.state.partial_contact}
                                        placeholder="Enter Patient phone no"
                                        onChange={(event) => {
                                          this.setState({
                                            partial_contact: event.target.value,
                                          });
                                          event.target.value.length < 9 ||
                                          event.target.value.length > 11
                                            ? this.setState({
                                                partial_contactError: (
                                                  <small className="text-danger">
                                                    Please enter patient phone
                                                    no from 9 to 11 digit.
                                                  </small>
                                                ),
                                              })
                                            : this.setState({
                                                partial_contactError: null,
                                              });
                                        }}
                                      ></FormControl>
                                    </Col>
                                    {this.state.partial_contactError}
                                  </Col>
                                </FormGroup>

                                <FormGroup>
                                  <ControlLabel>Patient Email</ControlLabel>
                                  <FormControl
                                    type="email"
                                    name="partial_email"
                                    value={this.state.partial_email}
                                    placeholder="Enter Patient Email"
                                    onChange={(event) => {
                                      this.setState({
                                        partial_email: event.target.value,
                                      });
                                      var emailRex =
                                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                      emailRex.test(event.target.value) ===
                                      false
                                        ? this.setState({
                                            partial_emailError: (
                                              <small className="text-danger">
                                                Patient Email format should be{" "}
                                                <i>abc@doe.com</i>.
                                              </small>
                                            ),
                                          })
                                        : this.setState({
                                            partial_emailError: null,
                                          });
                                    }}
                                  ></FormControl>
                                  {this.state.partial_emailError}
                                </FormGroup>
                              </>
                            ) : (
                              ""
                            )}

                            <FormGroup>
                              <ControlLabel>Symptoms</ControlLabel>
                              {/* {this.state.symptomsdata.map(s=>{

                              return <Checkbox  name="symptoms"  handlesymptoms={this.handlesymptoms} {...s} />
                            })} */}
                              {this.state.symptomsdata.map((s, i) => (
                                <Checkbox
                                  number={s.id}
                                  key={i}
                                  checked={s.checked}
                                  onChange={(e) => this.handlesymptoms(e, i)}
                                  label={s.label}
                                />
                              ))}
                            </FormGroup>
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col md={6} sm={6} xs={12}>
                        {this.state.userrole == 6 ||
                        this.state.userrole == 1 ||
                        this.state.userrole == 2 ? (
                          <>
                            <FormGroup>
                              <ControlLabel>Body Temperature</ControlLabel>
                              <FormControl
                                type="number"
                                placeholder="Enter Body Temperature"
                                onChange={this.onChange}
                                name="bodytem"
                                value={this.state.bodytem}
                                min={1}
                              ></FormControl>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>
                                Emergency Contact Person Number
                              </ControlLabel>
                              <Col md={12}>
                                <Col
                                  md={2}
                                  className="no-padding"
                                  style={{ marginTop: "4px" }}
                                >
                                  <select
                                    onChange={this.onChange}
                                    name="eccode"
                                    value={this.state.eccode}
                                    className="form-control"
                                  >
                                    <option value="+94">+94</option>
                                    <option value="+91">+91</option>
                                  </select>
                                </Col>
                                <Col md={10}>
                                  <FormControl
                                    type="number"
                                    name="emergency_contact_num"
                                    value={this.state.emergency_contact_num}
                                    placeholder="Enter Emergency Contact Person Contact Number"
                                    onChange={(event) => {
                                      this.setState({
                                        emergency_contact_num:
                                          event.target.value,
                                      });
                                      event.target.value.length < 9 ||
                                      event.target.value.length > 11
                                        ? this.setState({
                                            emergency_contact_numError: (
                                              <small className="text-danger">
                                                Please enter emergency contact
                                                person number from 9 to 11
                                                digit.
                                              </small>
                                            ),
                                          })
                                        : this.setState({
                                            emergency_contact_numError: null,
                                          });
                                    }}
                                  ></FormControl>
                                </Col>
                                {this.state.emergency_contact_numError}
                              </Col>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>
                                Epidemiological Evidence
                              </ControlLabel>
                              {this.state.Epidemiological_Evidence_data.map(
                                (s, i) => (
                                  <Checkbox
                                    number={s.id}
                                    key={i}
                                    checked={s.checked}
                                    onChange={(e) =>
                                      this.handleEpidemiological_Evidence(e, i)
                                    }
                                    label={s.label}
                                  />
                                ),
                              )}
                            </FormGroup>
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={12} xs={12} md={12}>
                        {this.state.addresslist.map((x, i) => {
                          const add =
                            x.latitude !== ""
                              ? `${x.latitude},${x.longitude}`
                              : "";
                          return x.is_active === 1 ? (
                            <div>
                              <h4 className="address_heading">
                                Address {x.srno}
                              </h4>
                              <a
                                style={{ float: "right" }}
                                href="javascript:void(0)"
                                onClick={(e) => this.handleRemoveClick(i)}
                              >
                                X
                              </a>

                              <Row>
                                {/* <Col
                                  md={6}
                                  xs={12}
                                  sm={6}
                                  style={{
                                    marginBottom: "70px",
                                  }}
                                >
                                  <div style={{ marginBottom: "20px" }}>
                                    <Autocomplete
                                      apiKey={
                                        "AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE"
                                      }
                                      options={{
                                        types: "(cities)",
                                        componentRestrictions: {
                                          country: "LK",
                                        },
                                      }}
                                      style={{
                                        width: "92%",
                                        padding: "8px 12px",
                                      }}
                                      onPlaceSelected={(place) =>
                                        this.handlePlaceSelected(place, i)
                                      }
                                    />
                                    <FormGroup>
                                      <ControlLabel>
                                        Enter a location
                                      </ControlLabel>
                                      <FormControl
                                        name="coordinates"
                                        type="text"
                                        placeholder="Enter your location"
                                        // value={x.customaddress}
                                        onChange={(e) =>
                                          this.handleInputLocationChange(e, i)
                                        }
                                      />
                                      {x.customaddressError}
                                    </FormGroup>
                                  </div>
                                  <div style={{ height: "380px" }}>
                                  <Map
                                      google={this.props.google}
                                      zoom={14}
                                      initialCenter={{
                                        lat: '6.895686610681836',
                                        lng: '79.88250590602851',
                                      }}
                                      onReady={this.onMapReady}
                                      style={{ width: "90%" }}
                                      center={{
                                        lat: lat || x.latitude || "6.9271",
                                        lng: lng || x.longitude || "79.8612",
                                      }}
                                    >
                                      <Marker
                                        // name={this.state.selectedPlace.name}
                                        position={{
                                          lat: lat || x.latitude || "6.9271",
                                          lng: lng || x.longitude || "79.8612",
                                        }}
                                      />
                                    </Map>
                                  <GoogleMap
                                      defaultZoom={8}
                                      defaultCenter={{
                                        lat: "6.895050683824454",
                                        lng: "79.89280524763893",
                                      }}
                                    >
                                      <Marker
                                        position={{
                                          lat: "6.895050683824454",
                                          lng: "79.89280524763893",
                                        }}
                                      />
                                    </GoogleMap>
                                  <GoogleMap
                                      center={{
                                        lat: lat || x.latitude || "6.9271",
                                        lng: lng || x.longitude || "79.8612",
                                      }}
                                      google={this.props.google}
                                      zoom={14}
                                      initialCenter={{
                                        lat: lat || x.latitude || "6.9271",
                                        lng: lng || x.longitude || "79.8612",
                                      }}
                                      onReady={this.onMapReady}
                                      style={{ width: "90%" }}
                                    >
                                      <Marker
                                        position={{ lat: lat, lng: lng }}
                                      />
                                    </GoogleMap>
                                  <div>
                                      <iframe
                                        width="100%"
                                        height="600"
                                        src={googleURL}
                                        frameborder="0"
                                        scrolling="no"
                                        marginheight="0"
                                        marginwidth="0"
                                      ></iframe>
                                      <br />
                                    </div>
                                  </div>
                                </Col> */}
                                <Col style={{ marginRight: "10px" }}>
                                  <Row style={{ marginLeft: "20px" }}>
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>
                                          Address Line 1
                                        </ControlLabel>
                                        <FormControl
                                          name="address_line_1"
                                          value={x.address_line_1}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter Address Line 1"
                                          type="text"
                                          // disabled
                                        />
                                        {this.state.address_line_1Error}
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>
                                          Address Line 2
                                        </ControlLabel>
                                        <FormControl
                                          name="address_line_2"
                                          value={x.address_line_2}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter Address Line 2"
                                          type="text"
                                          // disabled
                                        />
                                        {this.state.address_line_2Error}
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>
                                          Enter the location coordinates
                                        </ControlLabel>
                                        <FormControl
                                          name="coordinates"
                                          type="text"
                                          placeholder="Enter your location"
                                          value={add ? add : ""}
                                          onChange={(e) =>
                                            this.handleInputLocationChange(e, i)
                                          }
                                        />
                                        {/* {x.customaddressError} */}
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col style={{ marginRight: "10px" }}>
                                  <Row style={{ marginLeft: "20px" }}>
                                    <h5
                                      style={{
                                        textAlign: "left",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Add more details
                                    </h5>
                                    <Col
                                      md={6}
                                      xs={12}
                                      sm={6}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <ControlLabel>Address type</ControlLabel>
                                      <br></br>
                                      <select
                                        className="form-control"
                                        name="addresstype"
                                        onChange={(e) =>
                                          this.handleInputChange(e, i)
                                        }
                                        value={x.addresstype}
                                      >
                                        <option value="">
                                          Select address type
                                        </option>
                                        <option value="Home">Home</option>
                                        <option value="Office">Office</option>
                                        <option value="Custom">Custom</option>
                                      </select>
                                      {x.addresstypeError}
                                    </Col>
                                    <Col md={6} xs={12} sm={6}>
                                      {x.addresstype == "Custom" && (
                                        <FormGroup>
                                          <ControlLabel>
                                            Custom Address Field
                                          </ControlLabel>
                                          <FormControl
                                            name="customaddress"
                                            type="text"
                                            placeholder="Enter Custom Address Field"
                                            value={x.customaddress}
                                            onChange={(e) =>
                                              this.handleInputChange(e, i)
                                            }
                                          />
                                          {x.customaddressError}
                                        </FormGroup>
                                      )}
                                    </Col>
                                    {/* <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>
                                          Office number/ Apartment/ House number{" "}
                                        </ControlLabel>
                                        <FormControl
                                          name="address_line_2"
                                          value={x.address_line_2}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="E.g: 1/2 3rd Floor"
                                          type="text"
                                        />
                                      </FormGroup>
                                    </Col> */}
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>Country</ControlLabel>
                                        <select
                                          name="country"
                                          onChange={(e) =>
                                            this.handleInputChange(e, i, true)
                                          }
                                          value={x.country}
                                          className="form-control"
                                        >
                                          <option value="0">
                                            Select Country
                                          </option>
                                          {country.map((country) => (
                                            <option value={country.id}>
                                              {country.country_name}
                                            </option>
                                          ))}
                                        </select>
                                        {x.country_error}

                                        {this.state.countryError}
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>District</ControlLabel>
                                        <select
                                          className="form-control"
                                          name="city"
                                          value={x.city}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter City"
                                        >
                                          <option value="0">
                                            {" "}
                                            Select District
                                          </option>
                                          {this.state.city_info.map((city) => (
                                            <option value={city.id}>
                                              {city.city_name}
                                            </option>
                                          ))}
                                        </select>
                                        {x.city_error}
                                      </FormGroup>
                                    </Col>
                                    {/* <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>State</ControlLabel>
                                        <FormControl
                                          name="state"
                                          value={x.state}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter State"
                                          type="text"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col md={6} xs={12} sm={6}>
                                      <FormGroup>
                                        <ControlLabel>Postal Code</ControlLabel>
                                        <FormControl
                                          name="postalcode"
                                          value={x.postalcode}
                                          onChange={(e) =>
                                            this.handleInputChange(e, i)
                                          }
                                          placeholder="Enter Postal Code"
                                          type="number"
                                        />
                                      </FormGroup>
                                    </Col> */}
                                  </Row>
                                  {/* <Row></Row> */}
                                </Col>
                              </Row>

                              <hr></hr>
                            </div>
                          ) : (
                            ""
                          );
                        })}

                        <FormGroup>
                          <Button
                            class="btn-color"
                            fill
                            onClick={this.handleAddClick}
                          >
                            Add Address <i className="fa fa-plus"></i>
                          </Button>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Comment</ControlLabel>
                          <textarea
                            name="comment"
                            value={this.state.comment}
                            className="form-control"
                            onChange={(event) => {
                              this.setState({ comment: event.target.value });
                            }}
                            rows="3"
                            placeholder="Enter Comment"
                            type="textarea"
                          ></textarea>
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button
                      disabled={!this.state.processing}
                      onClick={this.onSubmit}
                      class="btn-color"
                      fill
                    >
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

// export default editlead;
export default GoogleApiWrapper({
  apiKey: "AIzaSyDYcP1T9HnFmllB0f_lMixg9EwNdkYCenE",
})(editlead);
